import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  token: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/passport/transfer/$transferId')({
  validateSearch: (search: Record<string, unknown>) => searchSchema.parse(search),
});
